import React from 'react';

import cn from 'classnames';

import { CustomModal } from '@shared/ui';
import { useGanttModal } from '@widgets/EstimateInformation/lib/hooks/useGanttModal';
import { PastStartDateWarningStep } from '@widgets/EstimateInformation/ui/modals/GanttModal/PastStartDateWarningStep';
import { ShiftStartDateFormStep } from '@widgets/EstimateInformation/ui/modals/GanttModal/ShiftStartDateFormStep';

import cls from './GanttModal.module.css';

interface GanttModalProps {
    isOpen: boolean;
    handleClose: () => void;
}

export const GanttModal = ({ isOpen, handleClose }: GanttModalProps) => {
    const { onSetFormModalType, onChangeStatusInExploitation, modalType } = useGanttModal();

    const typeMapping = {
        confirm: (
            <PastStartDateWarningStep
                onSetFormModalType={onSetFormModalType}
                onChangeStatusInExploitation={onChangeStatusInExploitation}
            />
        ),
        form: (
            <ShiftStartDateFormStep
                handleClose={handleClose}
                onChangeStatusInExploitation={onChangeStatusInExploitation}
            />
        ),
    };

    return (
        <CustomModal
            contentClasses={cn(cls.GanttModal, cls[modalType])}
            onHideModal={handleClose}
            isOpen={isOpen}
        >
            {typeMapping[modalType]}
        </CustomModal>
    );
};
